import store from '@/store';

export function tipoEmpresaName(id) {
  let results = store.getters.tipoEmpresas.filter(item => item.id === id);
  if (results.length === 1) {
    return results[0].value;
  } else {
    return '';
  }
}

export function provinciaName(id) {
  let results = store.getters.provincias.filter(item => item.cdprovin === id);
  if (results.length === 1) {
    return results[0].dsprovin;
  } else {
    return '';
  }
}

export function datosBancariosTitular(id) {
  let results = store.getters.datosBancarios.filter(item => item.idcuota === id);
  if (results.length === 1) {
    return results[0].titular;
  } else {
    return '';
  }
}

export function datosBancariosEntidad(id) {
  let results = store.getters.datosBancarios.filter(item => item.idcuota === id);
  if (results.length === 1) {
    return results[0].entidad;
  } else {
    return '';
  }
}

export function datosBancariosIban(id) {
  let results = store.getters.datosBancarios.filter(item => item.idcuota === id);
  if (results.length === 1) {
    return (
      results[0].iban.substr(0, 4) +
      ' ' +
      results[0].iban.substr(4, 4) +
      ' ' +
      results[0].iban.substr(8, 4) +
      ' ' +
      results[0].iban.substr(12, 2) +
      ' ' +
      results[0].iban.substr(14, 10)
    );
  } else {
    return '';
  }
}
